import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { MenuItem, Select, TextField } from "@material-ui/core";

const MoveDialog = ({
	open,
	setOpen,
	title,
	content,
	moveNote,
	setMoveNote,
	moveStatus,
	setMoveStatus,
	moveAppToQueue,
	appStatus,
}) => {
	return (
		<div>
			<Dialog
				maxWidth
				open={open}
				onClose={() => setOpen(false)}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description">
				<DialogTitle id="alert-dialog-title">{title}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{content}
					</DialogContentText>
					{appStatus && <Select
						onChange={(e) => setMoveStatus(e.target.value)}
						style={{ width: "75%", marginLeft: "10%" }}>
						{appStatus == "Credit Review" || appStatus == "Credit Adjudication" ? (
							<MenuItem value={"Asset Review"}>Asset Review</MenuItem>
						) : (
							<MenuItem value={"Dealmaker"}>Dealmaker</MenuItem>
						)}
					</Select>}
				</DialogContent>
				<DialogContent >
					<TextField
						id="notes"
						label="Notes"
						multiline
						rows={4}
						variant="outlined"
						style={{ width: '300px' }}
						value={moveNote}
						onChange={(e) => setMoveNote(e.target.value)}
					/>
					<div style={{ margin: 'auto', textAlign: 'center' }}>
						<Button
							disabled={!(moveStatus || moveNote) ? true : false}
							style={{ marginTop: "20px", marginBottom: "10px" }}
							onClick={() => {
								setOpen(false);
								moveAppToQueue();
							}}
							variant="contained"
							color="primary">
							Submit
						</Button>
						<Button
							style={{ marginTop: "20px", marginBottom: "10px", marginLeft: "30px" }}
							onClick={() => setOpen(false)}
							variant="contained"
							color="secondary">
							Close
						</Button>
					</div>
				</DialogContent>
			</Dialog>
		</div>
	);
};
export default MoveDialog;
